import { useQuery } from "react-query";
import { getLeasedEquipmentMakeList } from "../../../../../actions/Utilities/LeasedEquipmentMake";

export default function useGetMakeList() {
  return useQuery("GetMake", getLeasedEquipmentMakeList, {
    refetchOnWindowFocus: false,
  });
}
